export function computeSalePaidPendingAmounts(
  total: number,
  paymentStatus: string,
  nonCustomerPaid: number,
  customerAllocationPaid: number
): { paidAmount: number; pendingAmount: number } {
  const safeTotal = Number.isFinite(total) ? total : 0;
  const nonCustomer = Math.max(0, nonCustomerPaid);
  const customerPaid = Math.max(0, customerAllocationPaid);

  if (paymentStatus === 'paid') {
    return { paidAmount: safeTotal, pendingAmount: 0 };
  }
  if (paymentStatus === 'fiado') {
    return { paidAmount: customerPaid, pendingAmount: Math.max(0, safeTotal - customerPaid) };
  }
  if (paymentStatus === 'partial') {
    const paid = nonCustomer + customerPaid;
    return { paidAmount: paid, pendingAmount: Math.max(0, safeTotal - paid) };
  }
  if (paymentStatus === 'pending') {
    return { paidAmount: nonCustomer, pendingAmount: Math.max(0, safeTotal - nonCustomer) };
  }
  const paid = nonCustomer + customerPaid;
  return { paidAmount: paid, pendingAmount: Math.max(0, safeTotal - paid) };
}
